import React from "react";
import { Button } from "~/components/ui/Button";
import { CloseIcon } from "../icons/Close";

export function ImageUploader({
  images,
  revisionImageIds,
  onClick,
  onChange,
  onRemove,
}: {
  images: { id?: number; path: string; uploading?: boolean }[];
  revisionImageIds: Set<number>;
  onClick: (mdLink: string) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove: (index: number) => void;
}) {
  return (
    <div
      style={{
        display: "flex",
        gap: 8,
        flexWrap: "wrap",
        marginTop: 10,
      }}
    >
      {images.map((img, i) => {
        const isRevisionImage =
          img.id !== undefined && revisionImageIds.has(img.id);

        return (
          <div
            key={i}
            style={{
              width: 48,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 4,
            }}
          >
            {img.uploading ? (
              <div
                style={{
                  width: 48,
                  height: 48,
                  background: "#444",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 10,
                  color: "#fff",
                  borderRadius: 4,
                }}
              >
                ...
              </div>
            ) : (
              <img
                src={img.path}
                alt="preview"
                onClick={() => onClick(`::img[${img.path}]{float=center}`)}
                style={{
                  width: 48,
                  height: 48,
                  objectFit: "cover",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
              />
            )}

            {isRevisionImage && !img.uploading && (
              <Button onClick={() => onRemove(img.id!)}>
                <span style={{ width: 16, height: 16 }}>
                  <CloseIcon />
                </span>
              </Button>
            )}
          </div>
        );
      })}

      <label
        style={{
          width: 48,
          height: 48,
          border: "1px dashed #ccc",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          borderRadius: 4,
          fontSize: 24,
          userSelect: "none",
          flexDirection: "column",
        }}
      >
        +
        <input
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={onChange}
        />
      </label>
    </div>
  );
}
